import { useContext } from 'react'

import { ToastContext } from 'ui/components/Toast/toastContext'

export const useToast = () => {
    const context = useContext(ToastContext)

    return context.showToast
}
